<template>
<q-item
  v-if="latLng"
  clickable
  @click="showDialog = true"
>
  <q-item-section avatar>
    <q-avatar icon="share"/>
  </q-item-section>
  <q-item-section>
    <q-item-label>{{ $t('tools.share.title') }}</q-item-label>
  </q-item-section>
  <q-dialog v-model="showDialog">
    <q-card style="width: 450px">
      <q-card-section class="row items-center q-pt-md q-pb-xs">
        <q-icon name="share" style="font-size: 1.5em;" class="q-pr-sm"/>
        <div class="text-h6 q-pr-xl">{{ $t('tools.share.title') }}</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="showDialog = false" />
      </q-card-section>
      <div class="q-pa-md">
        <div>
        <i class="text-grey-8">
          Enllaç per compartir:
        </i>
        </div>
        <q-input
          ref="copy"
          :value="url"
          dense
        >
        <template v-slot:append>
          <q-btn
            flat
            dense
            icon="search"
            @click="open"
          >
          <q-tooltip>
            {{ $t('actions.openNewTab') | capitalize }}
          </q-tooltip>
          </q-btn>
          <q-btn
            :icon="feedback || copied > 0 ? 'fas fa-check' : 'fas fa-copy'"
            flat
            dense
            :ripple="false"
            @click="copy"
            @mouseleave="feedback = false"
            :color="feedback || copied > 0 ? 'green' : void 0"
          >
          <q-tooltip>
            {{ feedback || copied > 0 ? '' : $t('actions.copy') | capitalize }} URL
          </q-tooltip>
          </q-btn>
        </template>
        </q-input>
      </div>
    </q-card>
  </q-dialog>
</q-item>
</template>

<script>
import { mapState } from 'vuex'
import { QAvatar, QBtn, QCard, QCardSection, QDialog, QIcon, QInput, QSpace, QItem, QItemSection, QItemLabel, QTooltip } from 'quasar'

export default {
  components: {
    QAvatar, QBtn, QCard, QCardSection, QDialog, QIcon, QInput, QSpace, QItem, QItemSection, QItemLabel, QTooltip
  },
  data () {
    return {
      native: null,
      showDialog: false,
      copied: 0,
      feedback: false
    }
  },
  computed: {
    ...mapState({
      selectedCampaign: state => state.panorama.selectedCampaign,
      latLng: state => state.panorama.latLng,
      head: state => state.panorama.head,
      altitude: state => state.panorama.altitude
    }),
    url () {
      const baseUrl = document.location.origin + document.location.pathname.replace(/\/$/, '')
      const p = `${this.latLng.lat},${this.latLng.lng}`
      const head = this.head ? `${this.head}` : '0'
      const altitude = this.altitude ? `${this.altitude}` : '0'
      return `${baseUrl}/#/info/mapiastreets/${p}/${head}/${altitude}/`
    }
  },
  methods: {
    t (key) {
      return this.$t('tools.incidence.' + key)
    },
    copy () {
      this.native.select()
      document.execCommand('copy')
      // remove selection
      this.native.selectionEnd = this.native.selectionStart

      // user feedback
      this.feedback = true
      ++this.copied
      setTimeout(() => --this.copied, 1000)
    },
    open () {
      window.open(this.url, '_blank')
    }
  },
  watch: {
    showDialog (val) {
      if (val) {
        this.$nextTick(() => {
          this.native = this.$refs.copy.$el.querySelector('input')
        })
      } else {
        this.native = null
      }
    }
  }
}
</script>

<style>

</style>
